

















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { search_messages } from '@/api/message';
import { AppRoleType } from '@/utils/types';
import { formatTimeWithSecond } from '@/utils/index';

type HeaderType = {
  text: string;
  value: string;
};

@Component({
  name: 'MessageListResult',
})
export default class extends Vue {
  @Prop({ required: true }) messages!: search_messages.Message[];
  private headers: HeaderType[] = [];
  private loading = false;
  private filterText = '';
  private sortBy = 'sentAt';
  private sortDesc = true;

  get canShowAgent() {
    return UserModule.roles.some(r => (r as AppRoleType) !== AppRoleType.AGENT);
  }

  mounted() {
    this.loadHeaders();
  }

  private loadHeaders() {
    const agentName: HeaderType = {
      text: this.$t('Agent') as string,
      value: 'agentName',
    };
    const type: HeaderType = {
      text: this.$t('{msg} type', { msg: this.$t('Message') }) as string,
      value: 'type',
    };
    const subject: HeaderType = {
      text: this.$t('Subject') as string,
      value: 'subject',
    };
    const sentAt: HeaderType = {
      text: this.$t('Sent at') as string,
      value: 'sentAt',
    };
    const unread: HeaderType = {
      text: this.$t('Unread') as string,
      value: 'unread',
    };
    const id: HeaderType = {
      text: this.$t('Detail') as string,
      value: 'id',
    };
    const headers: HeaderType[] = this.canShowAgent
      ? [sentAt, type, agentName, subject, unread, id]
      : [sentAt, type, subject, unread, id];
    this.headers = headers;
  }

  private getSentAtText(sentAt: string) {
    return formatTimeWithSecond(new Date(sentAt));
  }

  private getTypeText(type: search_messages.Type) {
    return this.$t(`MessageTypeEnum.${type}`);
  }

  private getTypeIcon(type: search_messages.Type) {
    return (type as search_messages.Type) === search_messages.Type.SENT
      ? 'mdi-arrow-right'
      : (type as search_messages.Type) === search_messages.Type.RECEIVED
      ? 'mdi-arrow-left'
      : '';
  }
}
